import React from "react";
import "./StrengthsBlock.css";

function StrengthsBlock({ title, items }) {
  return (
    <section className="block block9">

      <h2 className="block9-title">{title || ''}</h2>

      <div className="block9-grid">
        {(items || []).map((item, index) => (
          <div key={index} className="strength-card">
            {item.icon && <img src={item.icon} alt={`${item.label || 'Strength'} icon`} />}
            <h3>{item.label || ''}</h3>
            <p>{item.description || ''}</p>
          </div>
        ))}
      </div>

    </section>
  );
}

export default StrengthsBlock;
